import { render, staticRenderFns } from "./RemoveUserDialog.vue?vue&type=template&id=abca0b96&"
import script from "./RemoveUserDialog.vue?vue&type=script&lang=js&"
export * from "./RemoveUserDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports